import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Icons from "@engineering/icons";
import CarTypes from "@engineering/icons/car-types";
import { IconWrapper } from "./Icon.styles";
var isCarPictogram = function(iconKey) {
    return Object.keys(CarTypes).includes(iconKey);
};
export var Icon = function(param) {
    var content = param.content, rules = param.rules;
    if (!content) {
        return null;
    }
    var ref = rules || {}, _color = ref.color, color = _color === void 0 ? "current" : _color, _indent = ref.indent, indent = _indent === void 0 ? 0 : _indent, _size = ref.size, size = _size === void 0 ? 50 : _size;
    var icon = content.key;
    var IconComponent = isCarPictogram(icon) ? CarTypes[icon] : Icons[icon];
    return /*#__PURE__*/ _jsx(IconWrapper, {
        color: color,
        size: size,
        indent: indent,
        children: /*#__PURE__*/ _jsx(IconComponent, {})
    });
};
